import { METAMASK_ERROR_CODE_USER_REJECTED } from '@/constants/main'

export function isUserRejectedError(error: unknown): boolean {
  if (!error) return false

  if (typeof error === 'object' && 'code' in error) {
    const code = (error as { code: unknown }).code
    if (code === METAMASK_ERROR_CODE_USER_REJECTED) return true
  }

  if (typeof error === 'object' && error !== null && 'cause' in error) {
    const cause = (error as { cause: unknown }).cause
    if (isUserRejectedError(cause)) return true
  }

  if (typeof error === 'object' && error !== null && 'shortMessage' in error) {
    const shortMessage = (error as { shortMessage: unknown }).shortMessage
    if (typeof shortMessage === 'string') {
      const lowerMessage = shortMessage.toLowerCase()
      const rejectionKeywords = [
        'user rejected',
        'user denied',
        'user cancelled',
        'user canceled',
        'rejected',
        'denied',
        'cancelled',
        'canceled',
      ]
      if (rejectionKeywords.some((keyword) => lowerMessage.includes(keyword))) {
        return true
      }
    }
  }

  const errorMessage =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
      ? error
      : String(error)

  const lowerMessage = errorMessage.toLowerCase()
  const rejectionKeywords = [
    'user rejected',
    'user denied',
    'user cancelled',
    'user canceled',
    'rejected',
    'denied',
    'cancelled',
    'canceled',
  ]

  return rejectionKeywords.some((keyword) => lowerMessage.includes(keyword))
}
